import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-123b6d77"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-theme"];
const _hoisted_2 = {
    key: 0,
    class: "FoldedCorner absolute"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Corner" }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
import { ref, computed } from "vue";
import { useElementSize } from "@vueuse/core";
import useFoldedCorner from "@/composables/useFoldedCorner";
import { round } from "@/utils/number.utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIDogEared',
    props: {
        folded: { type: Boolean, default: true },
        side: { default: "left" },
        width: { default: 50 },
        height: { default: 160 },
        theme: { default: "accent" },
        delay: { default: 0 }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "ecbe58ca": (_unref(opposite)),
            "557be5f6": (_unref(adjacent)),
            "4b9aed92": (_unref(width)),
            "0df3cadb": (_unref(height)),
            "7d6c8645": (_unref(y)),
            "4a67389f": (_unref(angle)),
            "43d15b5e": (props.delay)
        }));
        const props = __props;
        const root = ref(null);
        const { width: elWidth, height: elHeight } = useElementSize(root, { width: 100, height: 100 });
        const isPercentage = (v) => /^\d+(\.\d+)?%$/.test(v);
        const fromWidth = computed(() => typeof props.width === "string" ? (isPercentage(props.width) ? round(parseFloat(props.width) * elWidth.value / 100, 3) : parseFloat(props.width)) : props.width);
        const fromHeight = computed(() => typeof props.height === "string" ? (isPercentage(props.height) ? round(parseFloat(props.height) * elHeight.value / 100, 3) : parseFloat(props.height)) : props.height);
        const { adjacent, opposite, angle, y, width, height } = useFoldedCorner(fromWidth, fromHeight);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, {
                duration: 500 + _ctx.delay * 1000,
                appear: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref_key: "root",
                        ref: root,
                        class: _normalizeClass(["UIDogEared relative", [`UIDogEared--${_ctx.side}`, { folded: _ctx.folded }]]),
                        "data-theme": _ctx.theme
                    }, [
                        _renderSlot(_ctx.$slots, "default"),
                        (_ctx.folded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                            : _createCommentVNode("", true)
                    ], 10, _hoisted_1)
                ]),
                _: 3
            }, 8, ["duration"]));
        };
    }
});
